/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Action_LabelInputs */



/**
* | output |
* | --- |
* | "Import Transcript" |
*
* @param {Plain_Text_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_action_label = /** @type {((inputs?: Plain_Text_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer la transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import-Transkript")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт стенограммы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入成绩单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートトランスクリプト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेख आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar transcrição")
	return /** @type {LocalizedString} */ ("Import Transcript")
});